import React from 'react';
import classNames from 'classnames';

import { isVerifiedSeller } from '../../util/ctSellerPlan';

import css from './CtVerifiedBadge.module.css';

/**
 * Container Trader: "Verified Seller" badge. Renders only for approved sellers
 * (Console metadata ctSellerPlan = verified | growth | pro).
 */
const CtVerifiedBadge = props => {
  const { user, size = 'normal', className } = props;
  if (!isVerifiedSeller(user)) return null;
  return (
    <span
      className={classNames(css.root, { [css.small]: size === 'small' }, className)}
      title="Business reviewed and approved by Container Trader"
    >
      <svg
        className={css.icon}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M12 1.5l2.6 1.9 3.2-.1 1 3.1 2.6 1.9-1 3.1 1 3.1-2.6 1.9-1 3.1-3.2-.1L12 22.5l-2.6-1.9-3.2.1-1-3.1-2.6-1.9 1-3.1-1-3.1 2.6-1.9 1-3.1 3.2.1z"
        />
        <path
          d="M7.8 12.3l2.8 2.8 5.6-5.8"
          fill="none"
          stroke="#fff"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      Verified Seller
    </span>
  );
};

export default CtVerifiedBadge;
